import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ubt/ubt/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "how-to-contribute"
    }}>{`How to Contribute?`}</h3>
    <p>{`We beleive anything you do in the favour of the project seems to be a contribution. You can contribute in many ways,`}</p>
    <ul>
      <li parentName="ul">{`Use the project`}</li>
      <li parentName="ul">{`Share the project`}</li>
      <li parentName="ul">{`Star the project`}</li>
      <li parentName="ul">{`Suggest the project`}</li>
      <li parentName="ul">{`Critique the project`}</li>
      <li parentName="ul">{`Edit the docs`}</li>
      <li parentName="ul">{`Fork the project`}</li>
      <li parentName="ul">{`Code the project`}</li>
      <li parentName="ul">{`Maintain the Code`}</li>
      <li parentName="ul">{`Buy me an coffee`}</li>
    </ul>
    <h3 {...{
      "id": "what-happens-if-you-contribute"
    }}>{`What happens if you contribute?`}</h3>
    <p>{`We will be adding your name `}<a parentName="p" {...{
        "href": "https://mahadeer.github.io/ubt/#authors"
      }}>{`here`}</a>{`. But most importantly we have helped something on an open source project and helped develop somthing better.`}</p>
    <h3 {...{
      "id": "have-a-different-plan"
    }}>{`Have a different plan?`}</h3>
    <p>{`Please contact me on `}<a parentName="p" {...{
        "href": "mailto:mahadeer@outlook.com"
      }}>{`here`}</a>{`.`}</p>
    <p>Get to know more about the open source contibution from <a href="https://opensource.guide/how-to-contribute/" target="_blanks">here</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      